import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BInput from "@/components/singles/BInput/component.vue";

export default {
  name: "EditableText",
  components: {
    ValidationObserver,
    BInput
  },
  props: {
    name: String,
    label: String,
    type: String,
    validation: String,
    text: String,
    icon: String,
    placeholder: String,
    css: String,
    isLoading: Boolean
  },
  data() {
    return {
      originalValue: String,
      input: String
    };
  },
  created() {
    this.updateText(this.text);
  },
  mounted() {},
  methods: {
    updateText(text) {
      this.input = text;
    },

    async cancel() {
      if (!this.isLoading) this.$emit("cancel");
    },
    async save() {
      if (await this.$refs.observer.validate()) this.$emit("save", this.input);
    }
  }
};
